import _regeneratorRuntime from "/home/app/node_modules/@nrwl/web/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
var url = process.env.NEXT_PUBLIC_BFC_ENDPOINT;
export function axiosFetcher(query, variables) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res, data, message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.post(url, {
              query: query,
              variables: variables
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 2:
            res = _context.sent;
            data = res.data;

            if (!data.errors) {
              _context.next = 7;
              break;
            }

            message = data.errors[0].message;
            throw new Error(message);

          case 7:
            return _context.abrupt("return", data.data);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}